module.exports = __webpack_public_path__ + "img/1560978314.672a3776.jpg";